/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { ChakraProvider, useMediaQuery } from "@chakra-ui/react"
import theme from "../common/chakra-theme"
import PropTypes from "prop-types"
import Header from "../header/header2"
import Footer from "../footer"
import { GlobalStyle } from "../../components/common/style"
import { globalStyleVariables } from "../../styles/variables"
import DAMBanner from "../DAMBanner"
import TopBanner from "../TopBanner"

var defaultGettingStartedText =
  "Free until you’re ready to upgrade to the Premium plan"

const Layout = ({
  children,
  adLandingPage = false,
  damBanner = false,
  gettingStartedText = defaultGettingStartedText,
  primaryCTALink = "/registration",
  primaryCTAText = "Start my free plan",
  secondaryCTALink = "/contact-us",
  secondaryCTAText = "Talk to us",
  showContactUs = true
}) => {
  return (
    <>
      <GlobalStyle />
      {/* <div className="hero-bg">
        <img src="https://imagekit.io/static/img/newPages/homepage-wave-bg.svg"></img>
      </div> */}
      <ChakraProvider theme={theme}>
        <TopBanner ></TopBanner>
        {damBanner ? <DAMBanner /> : null}
        <Header spaceFromTop={"110px"} adLandingPage={adLandingPage} />
        <main>
          {children}
        </main>
        <Footer
          gettingStartedText={gettingStartedText}
          primaryCTALink={primaryCTALink}
          primaryCTAText={primaryCTAText}
          showContactUs={showContactUs}
          secondaryCTALink={secondaryCTALink}
          secondaryCTAText={secondaryCTAText}>
        </Footer>
      </ChakraProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
